import { useEffect } from 'react'

const ELEMENTS_TO_HIDE = [
  '#common-desktop-navigation-render',
  '.container-pre-footer',
  '.footer',
]

function hideElements() {
  ELEMENTS_TO_HIDE.forEach((selector) => {
    const element = document.querySelector(selector) as HTMLElement

    if (element) {
      element.style.display = 'none'
    }
  })
}

function enhanceLinks() {
  document.querySelectorAll('a').forEach((link) => {
    if (!link.dataset.webviewModified) {
      link.addEventListener('click', handleClick)
      link.dataset.webviewModified = 'true'
    }
  })
}

function handleClick(e: MouseEvent) {
  const target = e.currentTarget as HTMLAnchorElement

  if (target.href) {
    e.preventDefault()
    window.open(target.href, '_blank', 'noopener,noreferrer')
  }
}

export function WebViewDomChanges() {
  useEffect(() => {
    hideElements()
    enhanceLinks()

    const observer = new MutationObserver(() => {
      hideElements()
      enhanceLinks()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }, [])

  return null
}
